import type { AssetDetail } from "@/entities/asset";
import type { DatasetPlanPositioning } from "@/entities/dataset";

export const getPlanUrl = (
  dataset?: DatasetPlanPositioning,
  asset?: AssetDetail
) => {
  return dataset?.source_url ?? asset?.plan_file?.url;
};
